import React, { useEffect, useState } from 'react';
import style from '../../css/modals/VideoModal.module.css';

import { IoClose } from 'react-icons/io5';
import ReactPlayer from 'react-player/youtube';

function VideoModal({ modal, url, handlerClose }) {
	const [visibility, setVisibility] = useState('hidden');
	const [container, setContainer] = useState(style.videoClosed);

	useEffect(() => {
		if (modal) {
			setVisibility('visible');
			setTimeout(() => {
				setContainer('');
			}, 100);
		}
	}, [modal]);

	const handleCloseModal = (event) => {
		if (event.target.className === style.Video) {
			setContainer('video-closed');
			handlerClose();
			setVisibility('hidden');
		}
	};

	return (
		<div className={style.Video} style={{ visibility: `${visibility}` }} onClick={handleCloseModal}>
			<div className={`${style.videoContent} ${container}`}>
				<button
					className={style.videoCloser}
					onClick={() => {
						setContainer(style.videoClosed);
						handlerClose();
						setVisibility('hidden');
					}}
				>
					<IoClose />
				</button>
				<div className={`${style.videoContainer} ${container}`}>
					{modal ? (
						<ReactPlayer
							style={{ borderRadius: '20' }}
							className='react-player'
							url={url}
							playing={true}
							width='100%'
							height='100%'
							controls={true}
						/>
					) : null}
				</div>
			</div>
		</div>
	);
}

export default VideoModal;
